import gql from 'graphql-tag';

const GET_PLACES = gql`
  query getPlaces($params: PlacesInput!) {
    getPlaces(params: $params) {
      places {
        name
        dataSource
        uuid
        externalId
        address {
          street
          suite
          city
          state
          postal
          country
        }
        geocode {
          latitude
          longitude
        }
        categoriesV2 {
          code
          description
          type
        }
      }
      nextPage
    }
  }
`;

export { GET_PLACES };
